<template>
  <div>
    <PageHeader title="Times Up"></PageHeader>
    <h3>You have one more chance to retry.</h3>
    <div class="mt-4">
        <v-btn outlined large block 
        color="fanhiveHoney"
        @click="goToQuestions()"
        style="color: #ffffff !important;border: 1px solid #ffb300;"
        >Retry</v-btn>
      </div>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'questionstimesup',
  components: {
    PageHeader
  },
  methods: {
    goToQuestions: function () {
      this.$router.push({name: 'questions', query: { 
        entryId: this.$route.query.entryId,
        sportId: this.$route.query.sportId,
        totalQuestions: this.$route.query.totalQuestions,
        retry: parseInt(this.$route.query.retry)+1
      }});
    }
  },
  created () {
    
  }
}
</script>